import { render, staticRenderFns } from "./AddNavPopup.vue?vue&type=template&id=1041a622&scoped=true"
import script from "./AddNavPopup.vue?vue&type=script&lang=js"
export * from "./AddNavPopup.vue?vue&type=script&lang=js"
import style0 from "./AddNavPopup.vue?vue&type=style&index=0&id=1041a622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1041a622",
  null
  
)

export default component.exports